import { StateUtils } from '@spartacus/core';
import { WishlistEntry } from '@wishlist/const';

export const WISHLIST_FEATURE = 'wishlist';
export const WISHLIST_ENTRY_LIST = '[Wishlist] Entry list';
export const WISHLIST_ADD_ENTRY = '[Wishlist] Add entry';
export const WISHLIST_REMOVE_ENTRY = '[Wishlist] Remove entry';

export interface StateWithWishlist {
  [WISHLIST_FEATURE]: WishlistState;
}

export interface WishlistState {
  entryList: StateUtils.LoaderState<WishlistEntry[]>;
  addEntry: StateUtils.EntityLoaderState<WishlistEntry>;
  removeEntry: StateUtils.EntityLoaderState<WishlistEntry>;
}
